import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'

export interface AiNarrative {
  content: string
  model: string
  input_tokens: number
  output_tokens: number
  generated_at: string
}

export function useAiNarrative(forceRefresh = false) {
  return useQuery<AiNarrative>({
    queryKey: ['ai', 'narrative', forceRefresh],
    queryFn: () =>
      api.get<AiNarrative>(
        `/api/v1/ai/narrative${forceRefresh ? '?force_refresh=true' : ''}`,
      ),
    staleTime: 60 * 60 * 1000, // 1 ora — allineato al TTL Redis backend
    retry: 1,
  })
}
